var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"dismissible":"","prominent":"","type":"success","transition":"scale-transition"}},[_vm._v(" "+_vm._s(_vm.name)+" was successfully created ")])
}
var staticRenderFns = []

export { render, staticRenderFns }